<template>
  <section
    id="ticket-container"
    class="ticket-container"
  >
    <header class="ticket-container__header">
      <c-headline level="2">
        <slot name="title" />
      </c-headline>
    </header>

    <div class="ticket-container__container">
      <div class="ticket-container__main">
        <slot />

        <button
          class="ticket-container__open-sidebar"
          :aria-label="$t('openSidebar')"
          @click="openSidebar"
        >
          <c-icon
            type="cart"
          />
        </button>

        <c-banner
          v-if="$slots.banner"
          class="ticket-container__banner"
          color="primary"
        >
          <slot name="banner" />
        </c-banner>
      </div>

      <div
        id="ticket-container-sidebar"
        class="ticket-container__sidebar"
        :class="{
          'is-open': $store.state.showContainerSidebar
        }"
      >
        <c-cart-overview-reservations v-if="reservation" />
        <c-cart-overview-tickets v-else />
      </div>
    </div>
  </section>
</template>

<script>
import CBanner from './banner.vue'
import CCartOverviewReservations from './cartOverviewReservations.vue'
import CCartOverviewTickets from './cartOverviewTickets.vue'
import CHeadline from './headline.vue'
import CIcon from './icon.vue'

export default {
  name: 'CTicketContainer',

  components: {
    CBanner,
    CCartOverviewReservations,
    CCartOverviewTickets,
    CHeadline,
    CIcon
  },

  props: {
    reservation: {
      type: Boolean
    }
  },

  methods: {
    openSidebar () {
      this.$store.commit('showContainerSidebar', true)
    }
  }
}
</script>

<i18n locale="en">
{
  "openSidebar": "Open cart"
}
</i18n>

<i18n locale="de">
{
  "openSidebar": "Warenkorb öffnen"
}
</i18n>

<style lang="scss">
@import "../css/variables";
@import "../css/mixins";

.ticket-container {
  @include vertical-spacing;
}

.ticket-container__container {
  @media (min-width: $breakpoint-sidebar-min) {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
}

.ticket-container__header {
  margin-bottom: $gutter-sm;
  text-align: center;

  @media (min-width: $breakpoint-md) {
    margin-bottom: $gutter-md;
  }
}

.ticket-container__main {
  flex-grow: 1;
}

.ticket-container__sidebar {
  @media (max-width: $breakpoint-sidebar-max) {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: $z-index-sidebar;

    display: flex;
    width: 22em;
    max-width: 100%;

    visibility: hidden;

    .cart-overview {
      transform: translateX(-100%);
    }

    &::before {
      content: "";

      position: absolute;
      width: 100vw;
      height: 100%;

      background: hsl(0deg 0% 0% / 0.6);

      opacity: 0;
    }

    &.is-open {
      visibility: visible;

      .cart-overview {
        transform: translateX(0);
      }

      &::before {
        opacity: 1;
      }
    }

    @media (prefers-reduced-motion: no-preference) {
      transition: visibility 0.3s;

      .cart-overview {
        transition: transform 0.3s;
      }

      &::before {
        transition: opacity 0.3s;
      }
    }
  }

  @media (min-width: $breakpoint-sidebar-min) {
    flex-shrink: 0;
    position: sticky;
    width: 15rem;
    top: $gutter-sm;
    margin-top: 0;
    margin-left: $gutter-sm;
  }
}

.ticket-container__banner {
  margin-top: $gutter-sm;
  text-align: center;
}

.ticket-container__open-sidebar {
  position: fixed;
  bottom: $gutter-sm;
  right: $gutter-sm;
  z-index: $z-index-sidebar;

  padding: 0.5em;

  font-size: 1.5em;
  color: #fff;

  background: $color-primary-dark;
  border: 0;
  border-radius: 50%;
  box-shadow: 0 0.08em 0.5em hsla(0deg 0% 0% / 0.3);

  &:hover,
  &:focus {
    background: $color-secondary-dark;
  }

  .icon {
    display: block;
  }

  @media (min-width: $breakpoint-sidebar-min) {
    display: none;
  }
}
</style>
